import {Base} from "@/api/Base"

export class ReportGetTotalSalary extends Base {
    path = "report/getTotalSalaryByMonth"
}